import {IconBox, IconProps} from "../index";
import React from "react";

import RedditSvg from "../../../../assets/icons/social/reddit.svg?react";

export const RedditIcon = (props: IconProps) => {
    return (
        <IconBox {...props}>
            <RedditSvg/>
        </IconBox>
    );
}
